var _mask, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0264,
    y: 10.5,
    width: 23.9483,
    height: 27,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0264,
    y: 10.5,
    width: 23.9483,
    height: 27,
    rx: 2,
    className: "iconOrange",
    strokeWidth: 8,
    strokeLinecap: "round",
    mask: "url(#path-1-inside-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.4L22.75 27L29.5 21",
    className: "iconOrange",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.7858H5.38793C6.4925 11.7858 7.38793 12.6812 7.38793 13.7858V34.2143C7.38793 35.3189 6.4925 36.2143 5.38793 36.2143H2.5",
    className: "iconBlue",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 11.7858H44.6121C43.5075 11.7858 42.6121 12.6812 42.6121 13.7858V34.2143C42.6121 35.3189 43.5075 36.2143 44.6121 36.2143H47.5",
    className: "iconBlue",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationIcon);
export default __webpack_public_path__ + "static/media/AutomationIcon.b3b58be6ef653399d48dbd865bb3f7c6.svg";
export { ForwardRef as ReactComponent };